<div class="main">
    <div class="header">
        {{'MAP.map' | translate}}
        <i class="material-icons" (click)="closeModal();">clear</i>
    </div>
    <div *ngIf="!parentData.onlyMarkers" class="submitButton" style="margin-left: 215px;">
        <div class="button"  *ngIf="gpsLength" [ngStyle]="{'background-color': gpsMode? '#2f3b91':'#e4e4e4' , 'color': gpsMode? '#fff' : '#000'}" (click)="simMode = false; appMode = false; gpsMode = true;placeAllFavMarkers();">
            <img *ngIf="!gpsMode" src="assets/gps.svg" alt=""><img *ngIf="gpsMode" src="assets/gps-white.svg" alt=""><span class="label">Gps</span>
    
        </div>
      </div>
    <div *ngIf="!parentData.onlyMarkers" class="submitButton">
        <div class="button"  *ngIf="simLength" [ngStyle]="{'background-color': simMode? '#631d50':'#e4e4e4' , 'color': simMode? '#fff' : '#000'}" style="margin-left: 100px;"
            (click)="simMode = true; appMode = false;gpsMode = false;placeAllFavMarkers();">
            <img *ngIf="!simMode" src="assets/sim.svg" alt=""><img *ngIf="simMode" src="assets/sim-white.svg" alt=""><span class="label">Sim</span>
    
        </div>
    </div>
    <div *ngIf="!parentData.onlyMarkers" class="submitButton">
        <div class="button" *ngIf="appLength" [ngStyle]="{'background-color': appMode? '#631d50':'#e4e4e4' , 'color': appMode? '#fff' : '#000'}" (click)="simMode = false; appMode = true;gpsMode = false;placeAllFavMarkers();">
          <img *ngIf="!appMode" src="assets/app.svg" alt=""><img *ngIf="appMode" src="assets/app-white.svg" alt=""><span class="label">App</span>
    
        </div>
    </div>
    <div *ngIf="estimatedValues.estDistanceKms && estimatedValues.estTime" class="estimatedValues">
        <div class="distance">
            <div class="remainingDist">
                Remaining Distance: {{estimatedValues.estDistanceKms}}
            </div>
        </div>
        <div class="time">
            <div class="remainingTime">
                Remaining Time: {{estimatedValues.estTime}}
            </div>
        </div>
    </div>

    <div class="mapSection">
        <div class="map" id="pathMaps">
        </div>
    </div>
</div>